import React, { useState } from "react";
import { Key, Plus } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import Button from "../../components/Button/Button";
import ManageApiSearch from "../../components/ApiKeys/ManageApiSearch";
import CreateApiCredentials from "../../components/ApiKeys/CreateApiCredentials";
import LosCredentialsTable from "../../components/ApiKeys/los/LosCredentialsTable";
import CreateLosCredential from "../../components/ApiKeys/los/CreateLosCredential";

/* ===================== STYLES ===================== */
import styles from "./ApiKeys.module.scss";

const TABS = ["Marketplace", "LOS"];

const ApiKeys = () => {
  const [activeTab, setActiveTab] = useState("Marketplace");
  const [showCreate, setShowCreate] = useState(false);

  const switchTab = (tab) => {
    setActiveTab(tab);
    setShowCreate(false);
  };

  return (
    <div className={styles["admin-api-keys__page"]}>
      {/* TABS */}
      <div className={styles["admin-api-keys__tabs"]}>
        {TABS.map((tab) => (
          <button
            key={tab}
            className={`${styles["admin-api-keys__tab"]} ${
              activeTab === tab ? styles["admin-api-keys__tab--active"] : ""
            }`}
            onClick={() => switchTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* MARKETPLACE TAB (default) */}
      {activeTab === "Marketplace" &&
        (showCreate ? (
          <CreateApiCredentials onBack={() => setShowCreate(false)} />
        ) : (
          <>
            <div className={styles["admin-api-keys__header"]}>
              <div className={styles["admin-api-keys__icon-wrapper"]}>
                <Key size={24} strokeWidth={2.5} />
              </div>
              <div className={styles["admin-api-keys__title-group"]}>
                <h2 className={styles["admin-api-keys__title"]}>API Keys</h2>
                <p className={styles["admin-api-keys__subtitle"]}>
                  Your Auth 2.0 application credentials.
                </p>
              </div>
              <div className={styles["admin-api-keys__action"]}>
                <Button
                  icon={Plus}
                  text="New Credential"
                  onClick={() => setShowCreate(true)}
                />
              </div>
            </div>
            <ManageApiSearch />
          </>
        ))}

      {/* LOS TAB */}
      {activeTab === "LOS" &&
        (showCreate ? (
          <CreateLosCredential onBack={() => setShowCreate(false)} />
        ) : (
          <>
            <div className={styles["admin-api-keys__header"]}>
              <div className={styles["admin-api-keys__icon-wrapper"]}>
                <Key size={24} strokeWidth={2.5} />
              </div>
              <div className={styles["admin-api-keys__title-group"]}>
                <h2 className={styles["admin-api-keys__title"]}>
                  LOS Credentials
                </h2>
                <p className={styles["admin-api-keys__subtitle"]}>
                  Manage your LOS API credentials.
                </p>
              </div>
              <div className={styles["admin-api-keys__action"]}>
                <Button
                  icon={Plus}
                  text="New LOS Credential"
                  onClick={() => setShowCreate(true)}
                />
              </div>
            </div>
            <LosCredentialsTable />
          </>
        ))}
    </div>
  );
};

export default ApiKeys;
